<app-shared-workshop-card
  [title]="workshop.title"
  [coverImage]="workshop.coverImage"
  [rows]="cardRows"
  [actions]="cardActions"
></app-shared-workshop-card>
